module.exports = __webpack_public_path__ + "img/messaggio-risorse-alertmsg.da4c8489.png";